import React, { useState, useEffect } from 'react';

const FixedButton = ({ toggle, toggleComponent }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const divOffset = document.getElementById('targetDiv').offsetTop;
            const windowHeight = window.innerHeight;
            const divHeight = document.getElementById('targetDiv').clientHeight;


            const thresholdHeight = 0.3 * divHeight;
            if (!toggleComponent) {
                if (scrollPosition >= divOffset - thresholdHeight && scrollPosition <= divOffset + divHeight - windowHeight) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [toggleComponent]);





    const className = `${!toggleComponent ?
        'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2' :
        'flex mx-auto -translate-y-1/2'
        } shadow-md hover:shadow-lg text-black border-1.5 bg-[#FFCD50] border-[#FFCD50] py-2 px-4 rounded-lg transition-opacity ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`;




    return (
        <button
            className={className}
            onClick={toggle}
        >
            <div className='flex flex-row items-center gap-2'>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 3.77485L8 2.44152V16.2251L12 17.5585V3.77485ZM14 3.87745V17.8368L17.1414 17.3881C17.6341 17.3177 18 16.8958 18 16.3981V4.45903C18 3.85048 17.461 3.38302 16.8586 3.46908L14 3.87745ZM2.85858 2.61194L6 2.16316V16.1226L3.14142 16.5309C2.53899 16.617 2 16.1495 2 15.541V3.60189C2 3.10423 2.36593 2.68231 2.85858 2.61194ZM13 20L7 18L3.42426 18.5108C1.61696 18.769 0 17.3666 0 15.541V3.60189C0 2.10894 1.09779 0.84317 2.57573 0.63204L7 0L13 2L16.5757 1.48918C18.383 1.23099 20 2.63338 20 4.45903V16.3981C20 17.8911 18.9022 19.1568 17.4243 19.368L13 20Z" fill="black" />
                </svg>
                <span className='font-semibold'>عرض {toggleComponent ? 'القائمة' : 'الخريطة'}</span>
            </div>
        </button>
    );
};

export default FixedButton;
